const SQFT_PER_ACRE = 43560
const fromAcres = (acres: number) => acres * SQFT_PER_ACRE
const fromAcresOrNull = (acres: number | null | undefined) =>
  acres == null ? null : fromAcres(acres)

export const Sqft = {
  fromAcres,
  fromAcresOrNull,
}
